import { MenuItem, Select, OutlinedInput, FormControl, InputBase } from "@mui/material";
import { ReactComponent as Arrow } from "assets/icons/CircleArrow.svg";

const MediaSelect = ({ handleSelectChange, selectValue, from }) => {
  return (
    <FormControl sx={{ width: "12.4vw", height: "2.7vw" }}>
      <Select
        displayEmpty
        value={selectValue}
        onChange={handleSelectChange}
        input={<InputBase />}
        IconComponent={() => null}
        renderValue={(selected) => {
          if (!selected) {
            return (
              <span
                style={{
                  color: "#fff",
                  fontSize: "1vw",
                  fontWeight: 500,
                  fontFamily: "Poppins",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  marginLeft: "1vw",
                  marginRight: "1vw",
                }}
              >
                {`${from} Media`}
                <Arrow style={{ height: "2.5vh", width: "1.5vw" }} />
              </span>
            );
          }
          return selected === "add image" ? "Add Image" : "Add Video";
        }}
        sx={{
          color: "#fff",
          height: "2.65vw",
          borderRadius: "0.3vw",
          border: "0.1vw solid #8080808C !important",
          outline: "none !important",
          boxShadow: "none !important",
          "& .MuiSelect-select": {
            paddingRight: "0px !important",
            display: "flex",
            alignItems: "start ",
            justifyContent: "center",
            overflow: "visible !important",
            paddingLeft: "0px !important",
            padding: "0vw 0vw !important",
          },

          "& .MuiSvgIcon-root": {
            fill: "#fff",
            width: "1.7vw",
            height: "1.7vw",
            marginLeft: "0.5vw",
            flexShrink: 0,
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: "#fff",
              color: "#000",
              borderRadius: "0.3vw",
              "& .MuiMenuItem-root": {
                fontSize: "1vw",
                fontFamily: "Poppins",
                fontWeight: 500,
                backgroundColor: "#fff",
                "&:hover": {
                  backgroundColor: "#44444459",
                },
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none !important",
                },
                "&:hover fieldset": {
                  border: "none !important",
                },
                "&.Mui-focused fieldset": {
                  border: "none !important",
                },
              },
            },
          },
        }}
      >
        <MenuItem value="add image">{from === "Edit" ? "Edit" : "Add"} Image</MenuItem>
        <MenuItem value="add video">{from === "Edit" ? "Edit" : "Add"} Video</MenuItem>
      </Select>
    </FormControl>
  );
};

export default MediaSelect;
